import React from 'react';
import Layout from '../layouts/index';
import { Link, graphql } from 'gatsby';
import LatestBlogPosts from '../components/LatestBlogPosts.js';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import Subscribe from '../components/Subscribe'

const blogOverview = ({ data }) => {
  var numberOfFields = Object.keys(data.allMarkdownRemark.edges).length

  for (var i = 0; i < numberOfFields; i++) {
    // look for the entry with a matching `true` value
    if (data.allMarkdownRemark.edges[i].node.frontmatter.featuredpost === true) {
      // We found the iteration! Break the loop
      var testFeatured = data.allMarkdownRemark.edges[i];
      var featuredPostPath = testFeatured.node.frontmatter.path
      break;
    }
  }

  // var testFeatured = data.allMarkdownRemark.edges[i];
  // var featuredPostPath = testFeatured.node.frontmatter.path
  // const location = props.location;
  return (
    <Layout context="blog" bodyClass="page-home" ontouchstart>
      <SEO title="ChartHop Blog | ChartHop | The Org Management Platform" />
      <Helmet>
      
        <meta name="description" content="Curated resources to help you manage your team and grow intentionallly. Learn best practices for using ChartHop and stay up to date with the ChartHop team." />
        <meta property="og:url" content="https://www.charthop.com/blog" />
        <meta property="og:title" content="ChartHop Blog | ChartHop | The Org Management Platform" />
        <meta property="og:description" content="Curated resources to help you manage your team and grow intentionallly. Learn best practices for using ChartHop and stay up to date with the ChartHop team." />
        <meta property="og:image" content="https://www.charthop.com/blog/blog.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="ChartHop" />
        {/* Twitter Card tags */}
        <meta name="twitter:title" content="ChartHop Blog | ChartHop | The Org Management Platform" />
        <meta name="twitter:description" content="Curated resources to help you manage your team and grow intentionallly. Learn best practices for using ChartHop and stay up to date with the ChartHop team." />
        <meta name="twitter:image" content="https://www.charthop.com/blog/blog.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@charthop" />
        <meta name="twitter:creator" content="@charthop" />
      </Helmet>

      {/* LATEST POST */}
      {featuredPostPath !== undefined &&
        <section className="sectionSpacing">
          <div className="d-flex flex-column contentBlock">
            <div className="blogOverviewHeader">
              <a target="_blank" href={testFeatured.node.frontmatter.path}>
                <div>
                  <img src={testFeatured.node.frontmatter.featuredimage} alt="The ChartHop Team" />
                </div>
                <div className="sectionSpacing">
                  <p className="blogTaxonomy">{testFeatured.node.frontmatter.categories[0]}</p>
                  <h1>{testFeatured.node.frontmatter.title}</h1>
                  <p>{testFeatured.node.frontmatter.postsummary}</p>
                </div>
              </a>
            </div>
          </div>
        </section>
      }
      {/* POST CONTENT */}

      <LatestBlogPosts 
        excludePath={featuredPostPath}
        category="DEI"
        sectionClass="backgroundGradientContainer-Reverse" 
        ctaLink="https://www.charthop.com/blog/dei/"  
      />

      <LatestBlogPosts 
        excludePath={featuredPostPath}
        category="Org Chart"
        sectionClass="backgroundGradientContainer-Reverse" 
        ctaLink="https://www.charthop.com/blog/org-chart/" 
      />

      <LatestBlogPosts 
        excludePath={featuredPostPath}
        category="People Analytics"
        sectionClass="backgroundGradientContainer-Reverse" 
        ctaLink="https://www.charthop.com/blog/people-analytics/"  
      />

      <LatestBlogPosts 
        excludePath={featuredPostPath}
        category="Headcount Planning"
        sectionClass="backgroundGradientContainer-Reverse" 
        ctaLink="https://www.charthop.com/blog/headcount-planning/"  
      />

      <LatestBlogPosts 
        excludePath={featuredPostPath}
        category="Performance Management"
        sectionClass="backgroundGradientContainer-Reverse" 
        ctaLink="https://www.charthop.com/blog/best-practices/"  
      />
      
      <LatestBlogPosts
        excludePath={featuredPostPath}
        category="Best Practices"
        sectionClass="backgroundGradientContainer-Reverse"
        ctaLink="https://www.charthop.com/blog/best-practices/"
      />

      <LatestBlogPosts
        excludePath={featuredPostPath}
        category="Product Updates"
        sectionClass="backgroundGradientContainer-Reverse"
        ctaLink="https://www.charthop.com/blog/product-updates/"
        />

      <LatestBlogPosts
        excludePath={featuredPostPath}
        category="Company Updates"
        sectionClass="" 
        ctaLink="https://www.charthop.com/blog/company-updates/"
        />

      <Subscribe/>

      {/* LONG FORM */}
      <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
        <DemoFormLong source={"blog-demo-bottom"} headertext={HtmlParser("<h2 class='stillH1'>See ChartHop in action!</br></br> Request a demo now.</h2>")} focusID={HtmlParser("name")} />
      </section>

    </Layout>
  );
};

export default blogOverview;

export const query = graphql`
query blogOverviewQuery($featuredpost: Boolean = true) {
  allMarkdownRemark {
    edges {
      node {
        frontmatter @include(if: $featuredpost) {
          featuredpost
          title
          path
          categories
          featuredimage
          postsummary
        }
      }
    }
  }
}
`

